// Stan dzielony między modułami i inline <script> w HTML.

window.statElementCollector = {};
window.slidePositionVieved = {};

// flaga dla urządzeń z touch:
window.deviceTouch = 'ontouchstart' in document.documentElement;

// flaga dla scrollowania:
window.isScrolligFlag = false;

window.activeSlug = undefined;
window.lastReportedSlug = null;
// gdy strona się scrolluje to zmienna ma wartość true i nie wysyłamy statów na hover np. akordeon, hotpoint
window.isScrolling = false;
// czytane przez wpjslib
window.wp_content_selector = undefined;

// GA360 - push eventu do dataLayer
window.dataLayer = window.dataLayer || [];
window.custom360Action = function (data) {
  window.dataLayer.push(data);
};

// płaskie basicStatData (nie serwować {ga:{}}!)
window.statBase = undefined;
if (typeof basicStatData === 'undefined' || !basicStatData) {
  console.warn('_globals.js: brak zmiennej basicStatData');
} else {
  window.statBase = basicStatData.ga ? basicStatData.ga : basicStatData;
}
